/**
 * Saved Search CRUD services
 */

import { httpWithAuth } from '~/clients';
import { SAVED_SEARCH } from '~/constants/endpoints';
import { SavedSearch } from '~/contracts';

type SavedSearchResponse = {
  email: string;
  savedSearches?: SavedSearch[];
};

export function createSavedSearch(
  payload: {
    email: string;
    isEmailCampaignActive: boolean;
    name: string;
    url: string;
    userId: string;
    zip5: string;
  },
  controller?: AbortController
) {
  return httpWithAuth.post<SavedSearchResponse>(SAVED_SEARCH, payload, {
    signal: controller?.signal
  });
}

export function readSavedSearch(email: string, controller?: AbortController) {
  return httpWithAuth.get<SavedSearchResponse>(
    `${SAVED_SEARCH}?email=${email}`,
    {
      signal: controller?.signal
    }
  );
}

export function updateSavedSearch(
  payload: {
    email: string;
    isEmailCampaignActive: boolean;
    name: string;
    savedSearchId: number;
    url: string;
  },
  controller?: AbortController
) {
  return httpWithAuth.put<SavedSearchResponse>(SAVED_SEARCH, payload, {
    signal: controller?.signal
  });
}

export function deleteSavedSearch(
  payload: {
    email: string;
    savedSearchId: number;
  },
  controller?: AbortController
) {
  return httpWithAuth.delete<SavedSearchResponse>(SAVED_SEARCH, {
    data: payload,
    signal: controller?.signal
  });
}
